import { useState, useEffect } from 'react';
import liff from '@line/liff';
const LIFF_ID = import.meta.env.VITE_LIFF_ID || 'dev-liff-id';
export function useLiff() {
    const [state, setState] = useState({
        profile: null,
        isLoading: true,
        isInClient: false,
        isLoggedIn: false,
        error: null,
    });
    useEffect(() => {
        initLiff();
    }, []);
    async function initLiff() {
        try {
            await liff.init({ liffId: LIFF_ID });
            const isInClient = liff.isInClient();
            const isLoggedIn = liff.isLoggedIn();
            if (!isLoggedIn) {
                // In production LIFF, login is automatic inside LINE
                // In external browser, redirect to LINE login
                if (!isInClient) {
                    setState({
                        profile: null,
                        isLoading: false,
                        isInClient: false,
                        isLoggedIn: false,
                        error: null,
                    });
                    return;
                }
                liff.login();
                return;
            }
            const profile = await liff.getProfile();
            setState({
                profile: {
                    userId: profile.userId,
                    displayName: profile.displayName,
                    pictureUrl: profile.pictureUrl,
                },
                isLoading: false,
                isInClient,
                isLoggedIn: true,
                error: null,
            });
        }
        catch (err) {
            console.error('[LIFF] Init error:', err);
            setState({
                profile: null,
                isLoading: false,
                isInClient: false,
                isLoggedIn: false,
                error: err instanceof Error ? err.message : 'LIFF initialization failed',
            });
        }
    }
    return state;
}
//# sourceMappingURL=useLiff.js.map